import React from 'react';
import './StatsCard.css';

const StatsCard = ({ title, value, subtitle, icon }) => {
  return (
    <div className="stats-card">
      {icon && <div className="stats-card-icon">{icon}</div>}
      <div className="stats-card-content">
        <div className="stats-card-title">{title}</div>
        <div className="stats-card-value">{value}</div>
        {subtitle && <div className="stats-card-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default StatsCard;
